import { UtilsBrowser } from "../utils/UtilsBrowser";
import { routeShouldRenderComponent } from "../utils/UtilsLayout";
import {
  ROUTES_NO_COOKIE_NOTICE,
  ROUTES_NO_HEADER_AND_FOOTER,
  ROUTES_NO_HELP_TIPS,
} from "../configs/layout";

export const useRouteChecks = (pathname: string) => {
  const shouldShowCookieNotice =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_COOKIE_NOTICE);

  const shouldShowHeaderFooter =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_HEADER_AND_FOOTER);

  const shouldShowHelpTips =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_HELP_TIPS);

  return {
    shouldShowCookieNotice,
    shouldShowHeaderFooter,
    shouldShowHelpTips,
  };
};
